import { spotlightGradientStyle } from '../primitives/SpotlightBox';
import { useSpotlight } from '../../hooks/useSpotlight';
import { ACCENT, BORDER, EASE, FONT_MONO, SURFACE2, TEXT_SECONDARY } from '../../tokens';

export interface ResearchFinding {
  source: string;
  finding: string;
}

/** A single cited research finding, with spotlight and hover lift. */
export function ResearchCard({ source, finding }: ResearchFinding) {
  const { containerRef, spotRef, hovered, handlers } = useSpotlight<HTMLDivElement>();

  return (
    <div
      ref={containerRef}
      {...handlers}
      style={{
        padding: '16px 20px',
        background: SURFACE2,
        borderRadius: 12,
        border: `1px solid ${hovered ? 'rgba(255,107,0,0.35)' : BORDER}`,
        borderLeft: `3px solid ${ACCENT}`,
        transition: `border-color 0.3s, transform 0.35s ${EASE}, box-shadow 0.35s`,
        transform: hovered ? 'translateY(-5px) scale(1.015)' : 'translateY(0) scale(1)',
        boxShadow: hovered ? '0 16px 48px rgba(255,107,0,0.1)' : 'none',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'default',
      }}
    >
      <div ref={spotRef} aria-hidden="true" style={spotlightGradientStyle(hovered)} />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <div
          style={{
            fontFamily: FONT_MONO,
            fontSize: '0.6rem',
            color: ACCENT,
            letterSpacing: '0.1em',
            marginBottom: 6,
            textTransform: 'uppercase',
          }}
        >
          {source}
        </div>
        <blockquote style={{ fontSize: '0.88rem', color: TEXT_SECONDARY, lineHeight: 1.6, margin: 0 }}>
          &ldquo;{finding}&rdquo;
        </blockquote>
      </div>
    </div>
  );
}
